// /src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// --- imports για ΟΛΑ τα locales σου
import en from "./locales/en.json";
import enUS from "./locales/en-US.json";
import enGB from "./locales/en-GB.json";
import el from "./locales/el.json";
import es from "./locales/es.json";
import sv from "./locales/sv.json";
import ar from "./locales/ar.json";
import ur from "./locales/ur.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import ru from "./locales/ru.json";
import sr from "./locales/sr.json";
import hr from "./locales/hr.json";
import ro from "./locales/ro.json";
import sq from "./locales/sq.json";
import bg from "./locales/bg.json";
import zh from "./locales/zh.json";

const resources = {
  en: { translation: en },
  "en-US": { translation: enUS },
  "en-GB": { translation: enGB },
  el: { translation: el },
  es: { translation: es },
  sv: { translation: sv },
  ar: { translation: ar },
  ur: { translation: ur },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
  ru: { translation: ru },
  sr: { translation: sr },
  hr: { translation: hr },
  ro: { translation: ro },
  sq: { translation: sq },
  bg: { translation: bg },
  zh: { translation: zh }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    lng: "el",

    fallbackLng: {
      "en-US": ["en"],
      "en-GB": ["en"],
      default: ["en", "el"]
    },


    supportedLngs: ["en", "el"],

    nonExplicitSupportedLngs: true,

    interpolation: { escapeValue: false },

    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"]
    }
  });

i18n.on("languageChanged", (lng) => {
  const dir = i18n.dir(lng);
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lng);
  }
});

export default i18n;
